import React from 'react'
import { useState } from 'react'
import ProjectModal from './ProjectModal'
import { useTranslation } from 'react-i18next'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import ConstructionIcon from '@mui/icons-material/Construction';

const ProjectCard = ({ project }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslation();
  
    const toggleModal = () => {
      setIsModalOpen(!isModalOpen);
    };
  
    return (
      <div className="flex-shrink-0 w-3/4 sm:w-80">
        <div
          className="p-4 rounded-lg border shadow-lg transition-transform duration-300 cursor-pointer bg-background border-secondary hover:scale-105"
          onClick={toggleModal}
        >
          <div className="relative">
            <img 
              src={project.screenshots[0]} 
              alt={project.title}
              className="object-cover w-full h-32 rounded-md"
            />
            {/* Status Icons */}
            <div className="flex absolute top-2 right-2 gap-2">
              {project.isLive && (
                <div className="flex gap-1 items-center px-2 py-1 rounded-full backdrop-blur-sm bg-green-500/80" title={t("live")}>
                  <RocketLaunchIcon className="w-4 h-4 text-white" />
                  <span className="text-xs font-medium text-white">{t("live")}</span>
                </div>
              )}
              {project.isOngoing && (
                <div className="flex gap-1 items-center px-2 py-1 rounded-full backdrop-blur-sm bg-yellow-500/80" title={t("ongoing")}>
                  <ConstructionIcon className="w-4 h-4 text-white" />
                  <span className="text-xs font-medium text-white">{t("ongoing")}</span>
                </div>
              )}
            </div>
          </div>
          <h3 className="mt-4 text-lg font-bold">{project.title}</h3>
          <p className="text-sm text-gray-600 line-clamp-2">{t(project.description)}</p>
          
          {/* Tech Stack */}
          <div className="flex flex-wrap gap-1 mt-3">
            {project.stacks.map((tech, index) => (
              <span 
                key={index}
                className="px-2 py-0.5 text-xs text-blue-800 bg-blue-100 rounded-full dark:bg-blue-900 dark:text-blue-100"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>
  
        {/* Modal */}
        {isModalOpen && <ProjectModal toggleModal={toggleModal} project={project} />}
      </div>
    );
};

export default ProjectCard